import { useMemo } from 'react'
import qrcode from 'qrcode-generator'

/**
 * Karekod, tarayıcıda çiziliyor. Bağlama kodu bir giriş anahtarı gibi
 * çalıştığı için dışarıdaki bir QR servisine gönderilmiyor.
 */
export function QrCode({ value, size = 220, label }: { value: string; size?: number; label: string }) {
  const path = useMemo(() => {
    const qr = qrcode(0, 'M')
    qr.addData(value)
    qr.make()
    const n = qr.getModuleCount()
    let d = ''
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`
    return { d, n }
  }, [value])

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`-2 -2 ${path.n + 4} ${path.n + 4}`}
      shapeRendering="crispEdges"
      style={{ background: '#fff', borderRadius: 12, display: 'block' }}
    >
      <path d={path.d} fill="#0b0b0b" />
    </svg>
  )
}
